import Vue from 'vue';
import Vuetify from 'vuetify/lib';
import '@mdi/font/css/materialdesignicons.css'

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    options: {
      customProperties: true
    },
    dark: false,
    themes: {
      light: {
        primary: '#a00250',
        secondary: '#ffc300',
        accent: '#a00250'
      },
      dark: {
        primary: '#a00250',
        secondary: '#ffc300',
        accent: '#a00250'
      }
    }
  },
  icons: {
    iconfont: 'mdi'
  },
});
